import { useAppSelector } from "@/store/hooks"
import { allPieces } from "@/utils/data"

export const TurnStartedNotification: React.FC<
  TurnStartedNotificationProps
> = ({ playerOrder }) => {
  const myGameSituation = useAppSelector(
    (state) => state.global.myGame?.situation
  )
  const myGamePlayers = useAppSelector((state) => state.global.myGame?.players)

  const playerId = myGameSituation?.players.find(
    (player) => player.order === playerOrder
  )?.id
  const user = myGamePlayers?.find((user) => user.email === playerId)
  const player = myGameSituation?.players.find(
    (player) => player.order === playerOrder
  ) as IPlayer
  const piece = allPieces.find((item) => item.id === player?.pieceId)
  if (!piece) return null

  return (
    <div
      data-testid="notification.turn-started"
      className="fixed top-1/2 items-center gap-5 -translate-y-1/2 w-full py-10 font-semibold shadow-centerCardGlow border-auction-activeBorderColor border-t-4 border-b-4 flex justify-center text-5xl z-20 text-white font-poppins bg-[rgba(0,0,0,0.8)] auction-won-banner-pop-out"
    >
      <div className="flex items-center gap-4">
        <img src={piece?.imgSrc} className="h-11 w-11"></img>
        <div className="flex flex-col gap-2">
          <div className="">{user?.username}</div>
        </div>
      </div>
      turn started
    </div>
  )
}
